import { Button } from "@/ui-components/ui/button";
import { AuroraBackground } from "@/ui-components/ui/shadcn-io/aurora-background";
import { AlertCircle, LifeBuoy } from "lucide-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useFetchUserInfo } from "@/lib/api/requests/user-profile.requests";

const BannedPage = () => {
  const { fetchUserInfo } = useFetchUserInfo();
  const navigate = useNavigate();

  useEffect(() => {
    const checkBanStatus = async () => {
      try {
        await fetchUserInfo();
        // If request succeeds, user is not banned anymore
        navigate("/");
      } catch (error) {
        // User is still banned, stay on page
        console.error("User still banned:", error);
      }
    };

    checkBanStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="h-screen w-full bg-white text-black">
      <AuroraBackground variant="red">
        <div className="w-full max-w-2xl px-6 relative z-10">
          <div className="mx-auto flex flex-col items-center text-center">
            <div className="mb-6 grid place-items-center rounded-2xl bg-white/70 p-4 ring-1 ring-black/5 backdrop-blur">
              <AlertCircle className="h-9 w-9 text-red-600" />
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-2 tracking-tight">Dein Account wurde deaktiviert</h3>
            <p className="text-gray-500 max-w-md mx-auto leading-relaxed">
              Bitte wende dich an den Support, wenn es sich dabei um einen Fehler handelt!
            </p>

            <div className="flex flex-col sm:flex-row gap-2 justify-center w-full mt-6">
              <a href="mailto:support@sportypost.io">
                <Button 
                  className="w-full sm:w-auto h-11 px-8 rounded-xl bg-red-600 hover:bg-red-700 text-white shadow-sm transition-all flex items-center gap-2"
                >
                  <LifeBuoy className="w-4 h-4" />
                  Support kontaktieren
                </Button>
              </a>
            </div>
          </div>
        </div>
      </AuroraBackground>
    </div>
  );
};

export default BannedPage;
